document.addEventListener('DOMContentLoaded', function () {
  // --- CONFIG ---
  const coverageMap = { 15: 4.0, 18: 3.5, 20: 3.15 }; // sqm per kit

  // Your UI controls (the ones you added above the buy buttons)
  const depthSelect   = document.getElementById('depth-select');      // <select>
  const surfaceInput  = document.getElementById('surface-area');      // <input>
  const resultSpan    = document.getElementById('calculated-qty');    // <span>

  // Bail out quietly if widget isn’t present on this product
  if (!depthSelect || !surfaceInput || !resultSpan) return;

  // Find the product form and (later) its quantity input inside
  const productForm = document.querySelector('form[action*="/cart/add"]');
  let quantityInput = null;

  // Try common quantity selectors used by Ella
  function findQuantityInput() {
    if (!productForm) return null;
    return (
      productForm.querySelector('input[name="quantity"]') ||
      productForm.querySelector('input#Quantity') ||
      productForm.querySelector('input.qty') ||
      productForm.querySelector('.js-qty__num') ||
      productForm.querySelector('[data-quantity-input]') ||
      productForm.querySelector('input[type="number"]')
    );
  }

  // Some Ella layouts mount the input later; keep checking briefly
  function ensureQuantityInput(cb) {
    quantityInput = findQuantityInput();
    if (quantityInput) return cb();

    const triesMax = 20; // ~2s total
    let tries = 0;
    const iv = setInterval(() => {
      quantityInput = findQuantityInput();
      if (quantityInput || ++tries >= triesMax) {
        clearInterval(iv);
        cb();
      }
    }, 100);
  }

  function updateQuantity() {
    const depth = parseInt(depthSelect.value, 10);
    const area  = parseFloat(surfaceInput.value);

    // Guard invalid input
    if (!coverageMap[depth] || isNaN(area) || area <= 0) {
      resultSpan.textContent = '0';
      if (quantityInput) quantityInput.value = 0;
      return;
    }

    const kitsNeeded = Math.ceil(area / coverageMap[depth]);
    resultSpan.textContent = String(kitsNeeded);

    // Quantity input may still be absent on some templates
    if (quantityInput) {
      quantityInput.value = kitsNeeded;

      // If theme uses change listeners for qty, fire events
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Wire listeners
  depthSelect.addEventListener('change', updateQuantity);
  surfaceInput.addEventListener('input', updateQuantity);

  // Initialize once quantity field exists (or proceed without it)
  ensureQuantityInput(updateQuantity);

  // Optional: if your depth <option> displays "15 mm" make sure the value is numeric "15"
  // <option value="15">15 mm</option>
});